import { Stamp } from '@/components/UI/Stamp'
import { Typography } from '@/components/UI/Typography'
import { memo } from 'react'

type StampComponentsType = {
  query: number
  hasCount: number
  course: string | string[]
  img: string | null
  name: string
  spots: [
    {
      address: string
      id: number
      name: string
      zip: string
    },
  ]
  isRepeatStamp: boolean
  stampShape: 'circular' | 'square'
  onGroupModal: () => void
}

export const StampComponents = memo(
  ({ query: _query, hasCount, img, name, isRepeatStamp, stampShape, onGroupModal }: StampComponentsType) => {
    return (
      <>
        <button
          type="button"
          className="flex flex-col items-center justify-start w-full pt-4"
          onClick={() => {
            onGroupModal()
          }}
        >
          <Stamp
            type={img ? 'Get' : 'None'}
            src={img ?? undefined}
            size="Medium"
            shape={stampShape}
            count={isRepeatStamp ? hasCount : undefined}
          />

          <Typography variant="caption1" className="mt-1 break-words break-all">
            {name}
          </Typography>
        </button>
      </>
    )
  },
)
